import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import "@/App.css";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import { ForgotPassword, ResetPassword, VerifyEmail } from "@/pages/AuthExtras";
import Dashboard from "@/pages/Dashboard";
import PublicBio from "@/pages/PublicBio";
import PublicCart from "@/pages/PublicCart";
import PublicFunnel from "@/pages/PublicFunnel";
import Checkout from "@/pages/Checkout";
import ShopCheckout from "@/pages/ShopCheckout";
import GoogleCallback from "@/pages/GoogleCallback";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import { getToken } from "@/lib/api";
import { trackPageview } from "@/lib/analytics";

const Protected = ({ children }) => (getToken() ? children : <Navigate to="/login" replace />);

// Fires a GA4 page_view on every route change (no-op when GA4 ID unset)
const AnalyticsListener = () => {
  const location = useLocation();
  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
};

// Detect Emergent Google Auth callback synchronously (hash contains session_id)
const AppRouter = () => {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <GoogleCallback />;
  }
  return (
    <>
      <AnalyticsListener />
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Auth mode="login" />} />
      <Route path="/register" element={<Auth mode="register" />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/checkout/confirm/:orderId" element={<Protected><Checkout /></Protected>} />
      <Route path="/shop-checkout/:orderId" element={<ShopCheckout />} />
      <Route path="/dashboard/*" element={<Protected><Dashboard /></Protected>} />
      <Route path="/u/:slug" element={<PublicBio />} />
      <Route path="/u/:slug/cart" element={<PublicCart />} />
      <Route path="/f/:slug" element={<PublicFunnel />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#111318",
              color: "#FAFAFA",
              border: "1px solid rgba(250,204,21,0.4)",
              borderRadius: 0,
              fontFamily: "'IBM Plex Mono', monospace",
            },
          }}
        />
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
